import { dataToolboxSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconToolboxSolid = /*#__PURE__*/createIcon(dataToolboxSolid)
export default IconToolboxSolid
